import { render } from "./setting_section.vue?vue&type=template&id=6752c874&ts=true"
import script from "./setting_section.vue?vue&type=script&lang=ts"
export * from "./setting_section.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__